import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'

export const volumeTypesSelector = createSharedSelector(
  getDataSelector<DataKeys.VolumeTypes>(DataKeys.VolumeTypes),
  (volumeTypes) => {
    return volumeTypes.map((volumeType) => {
      // any model changes go here
      return {
        ...volumeType,
        // created_at: `${volume.created_at}Z`,
      }
    })
  },
)

export const volumeTypesSelectorFiltered = createSharedSelector(
  getDataSelector<DataKeys.VolumeTypes>(DataKeys.VolumeTypes),
  (volumeTypes) => volumeTypes.filter((volumeType) => volumeType.name !== '__DEFAULT__'),
)

export const defaultTenantVolumeTypesSelector = createSharedSelector(
  getDataSelector<DataKeys.TenantDefaultVolumeTypes>(DataKeys.TenantDefaultVolumeTypes),
  (defaultType) => {
    return defaultType[0] ?? { project_id: '', volume_type_id: '' }
  },
)

export const allDefaultVolumeTypeSelector = createSharedSelector(
  getDataSelector<DataKeys.AllTenantDefaultVolumeTypes>(DataKeys.AllTenantDefaultVolumeTypes),
  (defaultTypes) => {
    return defaultTypes?.[0]?.default_types ?? []
  },
)
